// import React, { useState } from "react";
// import { Box, Typography, Table, TableHead, TableRow, TableCell,
//          TableBody, Checkbox, Paper, Divider, Button, } from "@mui/material";

// interface ManageUserRightsProps {
//   userName: string; // For showing in header
//   onClose: () => void;
//   onSave: (data: any) => void;
// }

// interface RightItem {
//   section: string;
//   name: string;
//   permissions: { view: boolean; add: boolean; edit: boolean; delete: boolean };
// }

// const ManageUserRights: React.FC<ManageUserRightsProps> = ({
//   userName,
//   onClose,
//   onSave,
// }) => {
//   const [rights, setRights] = useState<RightItem[]>([
//     {
//       section: "Manage Tax",
//       name: "Tax",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//     {
//       section: "Manage Tax",
//       name: "Billing Tax Type",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//     {
//       section: "Manage Tax",
//       name: "Tax Calculation",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//     {
//       section: "Manage Item",
//       name: "Item Opening",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//     {
//       section: "Manage Item",
//       name: "Quick Opening",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//     {
//       section: "Manage Item",
//       name: "Device Pairing",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//     {
//       section: "Manage Item",
//       name: "Franchisee OutWard",
//       permissions: { view: false, add: false, edit: false, delete: false },
//     },
//   ]);

//   // Handle checkbox toggle
//   const handleToggle = (index: number, key: keyof RightItem["permissions"]) => {
//     const updated = [...rights];
//     updated[index].permissions[key] = !updated[index].permissions[key];
//     setRights(updated);
//   };

//   // Group by section
//   const groupedRights = rights.reduce((acc: any, item) => {
//     if (!acc[item.section]) acc[item.section] = [];
//     acc[item.section].push(item);
//     return acc;
//   }, {});

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         p: 3,
//         borderRadius: 2,
//         // backgroundColor: "#fff",
//       }}
//     >
//       <Box
//         sx={{
//           backgroundColor: "#7b1fa2",
//           color: "#fff",
//           p: 1.5,
//           borderRadius: 1,
//           mb: 2,
//         }}
//       >
//         <Typography variant="h6" fontWeight="bold">
//           ⚙ Managed User Rights - {userName}
//         </Typography>
//       </Box>

//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
//             <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
//               View
//             </TableCell>
//             <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
//               Add
//             </TableCell>
//             <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
//               Edit
//             </TableCell>
//             <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
//               Delete
//             </TableCell>
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {Object.keys(groupedRights).map((section) => (
//             <React.Fragment key={section}>
//               <TableRow>
//                 <TableCell
//                   colSpan={5}
//                   sx={{
//                     backgroundColor: "#f3e5f5",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {section}
//                 </TableCell>
//               </TableRow>

//               {groupedRights[section].map(
//                 (item: RightItem, index: number) => (
//                   <TableRow key={index}>
//                     <TableCell>{item.name}</TableCell>
//                     {(["view", "add", "edit", "delete"] as const).map((key) => (
//                       <TableCell align="center" key={key}>
//                         <Checkbox
//                           checked={item.permissions[key]}
//                           onChange={() => handleToggle(index, key)}
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 )
//               )}
//             </React.Fragment>
//           ))}
//         </TableBody>
//       </Table>

//       <Divider sx={{ my: 3 }} />

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           gap: 2,
//         }}
//       >
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => onSave(rights)}
//         >
//           Save
//         </Button>
//         <Button variant="outlined" color="secondary" onClick={onClose}>
//           Cancel
//         </Button>
//       </Box>
//     </Paper>
//   );
// };

// export default ManageUserRights;

import React, { useState, useEffect } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
         Checkbox, TextField, Typography, Paper, Button, Snackbar, Alert,
         CircularProgress,
         Divider,
        } from "@mui/material";

interface ManageUserRightsProps {
  userName: string;
  onClose: () => void;
  onSave: (data: any) => void;
}

interface RightItem {
  name: string;
  view: boolean;
  add: boolean;
  edit: boolean;
  del: boolean;
}

const ManageOperatorRights: React.FC<ManageUserRightsProps> = ({
  userName,
  onClose,
  onSave,
}) => {
  const [search, setSearch] = useState("");
  const [rights, setRights] = useState<RightItem[]>([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // ✅ Sample data (you can replace this with API)
  const initialRights: RightItem[] = [
    { name: "Manage Tax", view: true, add: true, edit: true, del: true },
    { name: "Billing Tax Type", view: true, add: false, edit: false, del: false },
    { name: "Tax Calculation", view: false, add: false, edit: false, del: false },
    { name: "Manage Item", view: true, add: true, edit: false, del: false },
    { name: "Device Pairing", view: false, add: false, edit: false, del: false },
    { name: "Franchisee OutWard", view: false, add: false, edit: false, del: false },
  ];

  // ✅ Load initial rights
  useEffect(() => {
    setRights(initialRights);
  }, []);

  // ✅ Handle checkbox change
 const handlePermissionChange = (
  index: number,
  field: keyof RightItem,
  value: boolean
) => {
  const updated = rights.map((item, i) =>
    i === index ? { ...item, [field]: value } : item
  );
  setRights(updated);
};

  // ✅ Save permissions
  const handleSave = async () => {
    setSaveLoading(true);
    try {
      const payload = {
        userName,
        permissions: rights.map((r) => ({
          name: r.name,
          permissions: {
            view: r.view,
            add: r.add,
            edit: r.edit,
            delete: r.del,
          },
        })),
      };

      console.log("Saving Payload:", payload);
      await new Promise((resolve) => setTimeout(resolve, 1000)); // mock delay

      setSnackbar({
        open: true,
        message: "User rights saved successfully!",
        severity: "success",
      });

      onSave(payload);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to save.",
        severity: "error",
      });
    } finally {
      setSaveLoading(false);
    }
  };

  // ✅ Search filter
  const filteredRights = rights.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#7b1fa2",
          color: "#fff",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderRadius: 2,
          mb: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          ⚙️ Manage User Rights - {userName}
        </Typography>

        <TextField
          size="small"
          placeholder="Search menus..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            borderRadius: 1,
            width: 250,
          }}
        />
      </Box>

      {/* Rights Table */}
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
         <TableHead>
  <TableRow>
    <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>

    {/* ✅ Select All for View */}
    <TableCell sx={{ fontWeight: "bold" }}>
      View
      <Checkbox
        checked={rights.length > 0 && rights.every((r) => r.view)}
        indeterminate={
          rights.some((r) => r.view) && !rights.every((r) => r.view)
        }
        onChange={(e) => {
          const checked = e.target.checked;
          setRights((prev) =>
            prev.map((r) => ({
              ...r,
              view: checked,
            }))
          );
        }}
      />
    </TableCell>

    {/* ✅ Select All for Add */}
    <TableCell sx={{ fontWeight: "bold" }}>
      Add
      <Checkbox
        checked={rights.length > 0 && rights.every((r) => r.add)}
        indeterminate={
          rights.some((r) => r.add) && !rights.every((r) => r.add)
        }
        onChange={(e) => {
          const checked = e.target.checked;
          setRights((prev) =>
            prev.map((r) => ({
              ...r,
              add: checked,
            }))
          );
        }}
      />
    </TableCell>

    {/* ✅ Select All for Edit */}
    <TableCell sx={{ fontWeight: "bold" }}>
      Edit
      <Checkbox
        checked={rights.length > 0 && rights.every((r) => r.edit)}
        indeterminate={
          rights.some((r) => r.edit) && !rights.every((r) => r.edit)
        }
        onChange={(e) => {
          const checked = e.target.checked;
          setRights((prev) =>
            prev.map((r) => ({
              ...r,
              edit: checked,
            }))
          );
        }}
      />
    </TableCell>

    {/* ✅ Select All for Delete */}
    <TableCell sx={{ fontWeight: "bold" }}>
      Delete
      <Checkbox
        checked={rights.length > 0 && rights.every((r) => r.del)}
        indeterminate={
          rights.some((r) => r.del) && !rights.every((r) => r.del)
        }
        onChange={(e) => {
          const checked = e.target.checked;
          setRights((prev) =>
            prev.map((r) => ({
              ...r,
              del: checked,
            }))
          );
        }}
      />
    </TableCell>
  </TableRow>
</TableHead>

<TableBody>
  {filteredRights.map((row, index) => (
    <TableRow key={index}>
      <TableCell>{row.name}</TableCell>

      <TableCell>
        <Checkbox
          checked={row.view}
          onChange={(e) =>
            handlePermissionChange(index, "view", e.target.checked)
          }
        />
      </TableCell>

      <TableCell>
        <Checkbox
          checked={row.add}
          onChange={(e) =>
            handlePermissionChange(index, "add", e.target.checked)
          }
        />
      </TableCell>

      <TableCell>
        <Checkbox
          checked={row.edit}
          onChange={(e) =>
            handlePermissionChange(index, "edit", e.target.checked)
          }
        />
      </TableCell>

      <TableCell>
        <Checkbox
          checked={row.del}
          onChange={(e) =>
            handlePermissionChange(index, "del", e.target.checked)
          }
        />
      </TableCell>
    </TableRow>
  ))}
</TableBody>

        </Table>
      </TableContainer>

      <Divider sx={{ my: 3 }} />

      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saveLoading}>
          {saveLoading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} /> Saving...
            </>
          ) : (
            "Save"
          )}
        </Button>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity as "success" | "error"}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ManageOperatorRights;
